const STORAGE_KEY = 'doroparty:raid-practice:admin-view:v1';

const STATUS_FILTERS = new Set(['all', 'done', 'partial', 'empty', 'input']);
const BOSS_FILTERS = new Set(['all', '1', '2', '3', '4', '5']);
const SORT_MODES = new Set(['default', 'presence', 'level']);
const VIEW_MODES = new Set(['records', 'table', 'recommendations']);

const DEFAULT_STATE = Object.freeze({
  query: '',
  statusFilter: 'all',
  bossFilter: 'all',
  sortMode: 'default',
  viewMode: 'records',
  singleBossView: false,
  practiceOnly: false,
  expandedMember: '',
  expandedSlotMembers: [],
});

function safeString(value, fallback = '') {
  return typeof value === 'string' ? value : fallback;
}

export function readRaidPracticeAdminViewState() {
  if (typeof window === 'undefined') return { ...DEFAULT_STATE };
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
    const statusFilter = safeString(parsed.statusFilter, DEFAULT_STATE.statusFilter);
    const bossFilter = safeString(parsed.bossFilter, DEFAULT_STATE.bossFilter);
    const sortMode = safeString(parsed.sortMode, DEFAULT_STATE.sortMode);
    const viewMode = safeString(parsed.viewMode, DEFAULT_STATE.viewMode);
    return {
      query: safeString(parsed.query),
      statusFilter: STATUS_FILTERS.has(statusFilter) ? statusFilter : DEFAULT_STATE.statusFilter,
      bossFilter: BOSS_FILTERS.has(bossFilter) ? bossFilter : DEFAULT_STATE.bossFilter,
      sortMode: SORT_MODES.has(sortMode) ? sortMode : DEFAULT_STATE.sortMode,
      viewMode: VIEW_MODES.has(viewMode) ? viewMode : DEFAULT_STATE.viewMode,
      singleBossView: Boolean(parsed.singleBossView),
      practiceOnly: Boolean(parsed.practiceOnly),
      expandedMember: safeString(parsed.expandedMember),
      expandedSlotMembers: Array.isArray(parsed.expandedSlotMembers)
        ? parsed.expandedSlotMembers.map((value) => String(value || '').trim()).filter(Boolean)
        : [],
    };
  } catch {
    return { ...DEFAULT_STATE };
  }
}

export function writeRaidPracticeAdminViewState(state = {}) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      query: safeString(state.query),
      statusFilter: STATUS_FILTERS.has(state.statusFilter) ? state.statusFilter : DEFAULT_STATE.statusFilter,
      bossFilter: BOSS_FILTERS.has(state.bossFilter) ? state.bossFilter : DEFAULT_STATE.bossFilter,
      sortMode: SORT_MODES.has(state.sortMode) ? state.sortMode : DEFAULT_STATE.sortMode,
      viewMode: VIEW_MODES.has(state.viewMode) ? state.viewMode : DEFAULT_STATE.viewMode,
      singleBossView: Boolean(state.singleBossView),
      practiceOnly: Boolean(state.practiceOnly),
      expandedMember: safeString(state.expandedMember),
      expandedSlotMembers: Array.isArray(state.expandedSlotMembers)
        ? state.expandedSlotMembers.map((value) => String(value || '').trim()).filter(Boolean)
        : [],
    }));
  } catch {
    // sessionStorage can be unavailable in private/restricted browser contexts.
  }
}
